"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SimpleWrapper = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleWrapper"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _FormFieldSelect = _interopRequireDefault(require("./FormFieldSelect"));

var _CancelButton = _interopRequireDefault(require("./CancelButton"));

var FormFieldSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FormFieldSelector, _PureComponent);

  function FormFieldSelector() {
    (0, _classCallCheck2.default)(this, FormFieldSelector);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldSelector).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldSelector, [{
    key: "langKey",
    value: function langKey(key) {
      return "leadFlowEditor.formFieldEditor." + key;
    }
  }, {
    key: "render",
    value: function render() {
      var onClick = this.props.onClick;
      return _react.default.createElement(_UIFormControl.default, {
        className: "form-field-selector",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('newFormField')
        })
      }, _react.default.createElement(_SimpleWrapper.default, null, _react.default.createElement(_FormFieldSelect.default, {
        afterAddHandler: onClick
      }), _react.default.createElement("div", null, _react.default.createElement(_CancelButton.default, {
        onClick: onClick
      }))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        onClick: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return FormFieldSelector;
}(_react.PureComponent);

exports.default = FormFieldSelector;
module.exports = exports.default;